import * as React from "react";
import Layout from "../../components/layout";
import PartnersProgramPage from "../../components/Partner-Program/PartnersProgramPage";
import Seo from "../../components/seo";


const IndustryExpertsIndex = () => (
  <Layout>
    <Seo title="Partner Programs | noissue" description="Make noissue your recommended sustainable solution and earn commissions off every order. Sustainable affiliate programs by noissue."/>
    <div className="noissue-industry-experts">
      <PartnersProgramPage />
    </div>
  </Layout>
)

export default IndustryExpertsIndex;
